import EntityBase from '@/data/EntityBase';
import type EntityState from '@/data/EntityState';
import { fetchPayroll } from '@/data/payrollCheck/actions/fetchPayroll';
import { fetchPayrollDetails } from '@/data/payrollCheck/actions/fetchPayrollDetails';
import { submitPayroll } from '@/data/payrollCheck/actions/submitPayroll';
import PayrollRecord from '@/data/payrollCheck/models/payrollRecord';
import generateThunkReducers from '@/data/util/generateThunkReducers';

import { createSlice } from '@reduxjs/toolkit';

export class DetailsState extends EntityBase<EntityState, { data: PayrollRecord }>({
  data: new PayrollRecord(),
}) {}

const initialState = new DetailsState();

const payrollDetails = createSlice({
  name: 'payrollCheck/details',
  initialState,
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
  },
  extraReducers: builder => {
    // Add reducers for additional action types here, and handle loading state as needed
    builder
      .addCase(fetchPayroll.fulfilled, (state, action) => {
        return state.setIn(['data'], new PayrollRecord(action.payload));
      })
      .addCase(fetchPayrollDetails.fulfilled, (state, action) => {
        return state.setIn(['data'], new PayrollRecord(action.payload));
      })
      .addCase(submitPayroll.fulfilled, (state, action) => {
        return state.update('data', () => new PayrollRecord(action.payload.payroll));
      });
    generateThunkReducers(builder, 'payrollCheck/details');
  },
});

export default payrollDetails.reducer;
